<div id="toast-container" class="toast toast-top-center toast-container">
  <div class="modal-body {{messageClass}} ngx-toastr ng-trigger ng-trigger-flyInOut">
    <div class="toast-title">{{header}}</div>
    <div [innerHTML]="message"></div>
    <!-- {{message}} -->
    <br />&nbsp;<br />&nbsp;
    <ng-template ngFor let-btn [ngForOf]="buttons" let-i="index">
      <button type="button" [class]="'btn btn-dark ' + 'btn-' + i"
        (click)="onButtonClick(btn.text)">{{btn.text}}</button>&nbsp;
    </ng-template>
  </div>
</div>
